import react, { useState } from "react";
import Collapsible from "react-collapsible";
import { Link } from "react-router-dom/cjs/react-router-dom";
import SmallCircle from "../../../../../../Assets/Images/small-circle.svg";

const MobileMSSStarterItem = (props) => {
  const [IsOpen, setIsOpen] = useState(false);

  const redirectToRoute = () => {
    if (props.LinkTo) {
      document.getElementById("link-to-" + props.LinkTo).click();
    }
  };

  return (
    <div className="mobile-mss-starter-item">
      {props.LinkTo ? (
        <Link id={"link-to-" + props.LinkTo} to={props.LinkTo}></Link>
      ) : null}
      {props.IsCollapsible ? (
        <Collapsible
          onOpening={() => setIsOpen(true)}
          onClosing={() => setIsOpen(false)}
          trigger={
            <section className="mobile-grid-item">
              <img alt="" src={props.Icon} />
              <p className="item-title">{props.Title}</p>
              {IsOpen ? (
                <i className="feather-minus"></i>
              ) : (
                <i className="feather-plus"></i>
              )}
            </section>
          }
        >
          <section className="collapsible-content">
            {props.Links.map((Item) => (
              <Link to={Item.route}>
                <div className="mobile-grid-link">
                  <img alt="." src={SmallCircle} />
                  {Item.name}
                  <i className="feather-chevron-right"></i>
                </div>
              </Link>
            ))}
          </section>
        </Collapsible>
      ) : (
        <section
          className="mobile-grid-item"
          onClick={
            props.ClickAction
              ? () => props.ClickAction()
              : () => redirectToRoute()
          }
        >
          <img alt="" src={props.Icon} />
          <p className="item-title">{props.Title}</p>
          <i className="feather-chevron-right"></i>
        </section>
      )}
    </div>
  );
};

export default MobileMSSStarterItem;
